<template>
	<div>
		<div class="md:hidden w-6"></div>
		<aside
			class="w-80 xl:w-64 transition-all duration-300 md:fixed md:overflow-y-auto md:pt-12 z-10 bottom-0 top-0 h-full pb-4 flex flex-col justify-between"
			:class="{ hidden: !menuOpened && isMobileView }"
		>
			<NavigationList class="overflow-x-hidden">
				<div>
					<NavigationGroup :title="$t('general_title').toString()">
						<NavigationLink
							:link="{ name: 'Dashboard' }"
							title="Dashboard"
							fa-icon-type="fas"
							fa-icon-name="tachometer-alt"
							:disabled="checkPaymentStatus"
						/>
					</NavigationGroup>

					<NavigationGroup
						v-if="isUserAllowedInLevel2 && this.$store.getters.getUser.person.company.id === getL2AdminID()"
						:title="$t('administration').toString()"
					>
						<NavigationLink
							:link="{ name: 'management' }"
							:title="$t('customer_base').toString()"
							fa-icon-type="fas"
							fa-icon-name="eye"
							:disabled="checkPaymentStatus"
							v-if="isUserAllowedInLevel5or6"
						/>
						<NavigationLink
							:link="{ name: 'repair_shop.chats' }"
							:title="$t('chats').toString()"
							fa-icon-type="fas"
							:notification-count="getNotificationCount"
							fa-icon-name="comments"
							:disabled="checkPaymentStatus"
							v-if="isUserAllowedInLevel5or6"
						/>
						<NavigationLink
							:link="{ name: 'damagecases' }"
							:title="$t('processes').toString()"
							fa-icon-type="fas"
							fa-icon-name="eye"
							:active="checkActiveStatus('management/customer')"
							v-else
						/>
						<NavigationLink
							:link="{ name: 'payment' }"
							:title="$t('opo_management').toString()"
							fa-icon-type="fas"
							fa-icon-name="money-bill-wave-alt"
							v-if="isUserAllowedInLevel2"
						/>

						<NavigationLink
							:link="{ name: 'invitations' }"
							:title="$t('invitations').toString()"
							fa-icon-type="fas"
							fa-icon-name="user-plus"
							v-if="isUserAllowedInLevel3"
						/>
					</NavigationGroup>

					<NavigationGroup title="L7 Fälle" v-if="isUserAllowedInLevel2 && this.$store.getters.getUser.person.company.id === getL2AdminID()">
						<NavigationLink
							title="Maklervergütung"
							:link="{ name: 'compensations' }"
							fa-icon-type="fas"
							fa-icon-name="coins"
							v-if="isLevel2Admin"
							:active="checkActiveStatus('broker-compensation')"
						/>
						<NavigationLink
							title="Maklerfälle"
							:link="{ name: 'brokerCaseOverview' }"
							fa-icon-type="fas"
							fa-icon-name="user-tie"
							v-if="isLevel2Admin"
							:active="checkActiveStatus('broker-cases')"
						/>
						<NavigationLink
							title="Gutachterfälle"
							:link="{ name: 'damageAssessorCaseOverview' }"
							fa-icon-type="fas"
							fa-icon-name="user-tie"
							v-if="isLevel2Admin"
							:active="checkActiveStatus('damage-assessor-cases')"
						/>
					</NavigationGroup>

					<NavigationGroup :title="$t('my_company').toString()" v-if="!isLevel1 && !isUserAllowedInLevel2">
						<NavigationLink
							v-if="isAuthenticatedUserInGroupAdmin"
							:link="{ name: 'CompanyProfile' }"
							:title="$t('company_data').toString()"
							fa-icon-type="fas"
							fa-icon-name="building"
							:disabled="checkPaymentStatus"
						/>
						<NavigationLink
							v-if="isAuthenticatedUserInGroupAdmin && isUserAllowedInLevel5or6"
							:link="{ name: 'ManagePayment' }"
							:title="$t('manage_payment').toString()"
							fa-icon-type="fas"
							fa-icon-name="money-bill"
						/>
						<NavigationLink
							v-if="isAuthenticatedUserInGroupAdmin"
							:link="{ name: 'ContractManagement' }"
							:title="$t('contract_management').toString()"
							:disabled="checkPaymentStatus"
							fa-icon-type="fas"
							fa-icon-name="file-contract"
						/>
						<NavigationLink
							:link="{ name: 'companychildren' }"
							:title="$t('child_company').toString()"
							fa-icon-type="fas"
							fa-icon-name="city"
							:disabled="checkPaymentStatus"
							v-if="isUserAllowedInLevel5or6 && isParentCompany"
						/>
						<NavigationLink
							:link="{ name: 'OpeningHours' }"
							:title="$t('opening_hours').toString()"
							fa-icon-type="fas"
							fa-icon-name="door-open"
							:disabled="checkPaymentStatus"
							v-if="isUserAllowedInLevel5or6 && isAuthenticatedUserInGroupAdmin"
						/>
						<NavigationLink
							:link="{ name: 'employees' }"
							:title="$t('employees').toString()"
							fa-icon-type="fas"
							fa-icon-name="user-friends"
							v-if="isAuthenticatedUserInGroupAdmin"
							:disabled="checkPaymentStatus"
							:active="checkActiveStatus('employees') || checkActiveStatus('userprofile/new')"
						/>
						<NavigationLink
							:link="{ name: 'vacations' }"
							:title="$t('absence_planner').toString()"
							fa-icon-type="fas"
							fa-icon-name="calendar-alt"
							:disabled="checkPaymentStatus"
							v-if="isUserAllowedInLevel5or6"
						/>
						<NavigationLink
							:link="{ name: 'statistics' }"
							:title="$t('statistics').toString()"
							fa-icon-type="fas"
							fa-icon-name="chart-bar"
							:disabled="checkPaymentStatus"
							v-if="isUserAllowedInLevel5or6 && isAuthenticatedUserInGroupAdmin"
						/>
						<NavigationLink
							:link="{ name: 'companyvariables' }"
							:title="$t('additional_services').toString()"
							fa-icon-type="fas"
							fa-icon-name="cogs"
							:disabled="checkPaymentStatus"
							v-if="isUserAllowedInLevel5or6 && isAuthenticatedUserInGroupAdmin"
						/>
						<NavigationLink
							:link="{ name: 'forms' }"
							:title="$t('forms').toString()"
							fa-icon-type="fas"
							fa-icon-name="file"
							:disabled="checkPaymentStatus"
							v-if="isUserAllowedInLevel5or6 && isAuthenticatedUserInGroupAdmin"
						/>
						<NavigationLink
							:link="{ name: 'DocumentDefinitionsOverview' }"
							:title="$t('document_definitions.sidebar').toString()"
							fa-icon-type="fas"
							fa-icon-name="file-pdf"
							:active="checkActiveStatus('document-definitions')"
							v-if="isUserAllowedInLevel3 && isAuthenticatedUserInGroupAdmin"
						/>
					</NavigationGroup>

					<NavigationGroup :title="$t('admin_management').toString()" v-if="isLevel1Admin || isLevel2Admin">
						<NavigationLink
							:link="{ name: 'CompanyProfile' }"
							:title="$t('company_data').toString()"
							fa-icon-type="fas"
							fa-icon-name="building"
							v-if="isLevel2Admin"
						/>
						<NavigationLink
							:link="{ name: 'employees' }"
							:title="isLevel1Admin ? $t('admin_accounts_l1').toString() : $t('employees').toString()"
							fa-icon-type="fas"
							fa-icon-name="user-friends"
							:active="(checkActiveStatus('employees') && !isRouteActive('company_employees')) || checkActiveStatus('userprofile/new')"
						/>

						<NavigationLink
							:link="{ name: 'damageassessor.IndexCompanies', params: { type: 'car_dealership' } }"
							:title="$t('car_shops').toString()"
							fa-icon-type="fas"
							fa-icon-name="tools"
							:active="$route.params.type === 'car_dealership'"
							v-if="isLevel2Admin"
						/>

						<NavigationLink
							:link="{ name: 'damageassessor.IndexCompanies', params: { type: 'repairShop' } }"
							:title="$t('repair_shops').toString()"
							fa-icon-type="fas"
							fa-icon-name="city"
							:active="$route.params.type === 'repairShop'"
							v-if="isLevel2Admin"
						/>
						<NavigationLink
							:link="{ name: 'forms' }"
							:title="$t('forms').toString()"
							fa-icon-type="fas"
							fa-icon-name="file"
							v-if="isLevel2Admin && isAuthenticatedUserInGroupAdmin"
						/>
						<NavigationLink
							:link="{ name: 'PdfBlueprintsOverview' }"
							:title="$t('pdf_templates').toString()"
							fa-icon-type="fas"
							fa-icon-name="file-pdf"
							:active="checkActiveStatus('pdf-blueprints')"
							v-if="isLevel2Admin && isAuthenticatedUserInGroupAdmin"
						/>
						<NavigationLink
							:link="{ name: 'DocumentDefinitionsOverview' }"
							:title="$t('document_definitions.sidebar').toString()"
							fa-icon-type="fas"
							fa-icon-name="file-pdf"
							:active="checkActiveStatus('document-definitions')"
							v-if="isLevel2Admin || (isUserAllowedInLevel4 && isAuthenticatedUserInGroupAdmin)"
						/>
					</NavigationGroup>

					<NavigationGroup :title="$t('level_administration').toString()" v-show="isUserAllowedInLevel1">
						<NavigationLink
							:link="{ name: 'administrate_companies', params: { type: 'damageassessor' } }"
							:title="$t('damage_assessor').toString()"
							fa-icon-type="fas"
							fa-icon-name="user-secret"
							:active="$route.params.type === 'damageassessor'"
						/>

						<NavigationLink
							:link="{ name: 'administrate_companies', params: { type: 'lawyerOffice' } }"
							:title="$t('lawyers_offices').toString()"
							fa-icon-type="fas"
							fa-icon-name="gavel"
							:active="$route.params.type === 'lawyerOffice'"
						/>

						<NavigationLink
							:link="{ name: 'administrate_companies', params: { type: 'car_dealership' } }"
							:title="$t('car_shops').toString()"
							fa-icon-type="fas"
							fa-icon-name="city"
							:active="$route.params.type === 'car_dealership'"
						/>

						<NavigationLink
							:link="{ name: 'administrate_companies', params: { type: 'repairShop' } }"
							:title="$t('repair_shops').toString()"
							fa-icon-type="fas"
							fa-icon-name="tools"
							:active="$route.params.type === 'repairShop'"
						/>
					</NavigationGroup>

					<NavigationGroup title="Premiumpartner" v-if="isUserAllowedInLevel2 && this.$store.getters.getUser.person.company.id === getL2AdminID()">
						<NavigationLink
							title="Abrechnung"
							:link="{ name: 'premiumcasereferrals' }"
							fa-icon-type="fas"
							fa-icon-name="file-invoice"
							v-if="isLevel2Admin"
							:active="checkActiveStatus('premium-partner-compensations')"
						/>
						<NavigationLink
							title="Premium Kanzleien"
							:link="{ name: 'premiumpartners' }"
							fa-icon-type="fas"
							fa-icon-name="gavel"
							v-if="isLevel2Admin"
							:active="checkActiveStatus('premium-partner-overview')"
						/>
					</NavigationGroup>

					<NavigationGroup
						v-if="!(isUserAllowedInLevel2 && this.$store.getters.getUser.person.company.id === getL2AdminID())"
						:title="$t('administration').toString()"
					>
						<NavigationLink
							:link="{ name: 'management' }"
							:title="$t('customer_base').toString()"
							fa-icon-type="fas"
							fa-icon-name="eye"
							:disabled="checkPaymentStatus"
							v-if="isUserAllowedInLevel5or6"
						/>
						<NavigationLink
							:link="{ name: 'repair_shop.chats' }"
							:title="$t('chats').toString()"
							fa-icon-type="fas"
							:notification-count="getNotificationCount"
							fa-icon-name="comments"
							:disabled="checkPaymentStatus"
							v-if="isUserAllowedInLevel5or6"
						/>
						<NavigationLink
							:link="{ name: 'damagecases' }"
							:title="$t('processes').toString()"
							fa-icon-type="fas"
							fa-icon-name="eye"
							:active="checkActiveStatus('management/customer')"
							v-else
						/>
						<NavigationLink
							:link="{ name: 'payment' }"
							:title="$t('opo_management').toString()"
							fa-icon-type="fas"
							fa-icon-name="money-bill-wave-alt"
							v-if="isUserAllowedInLevel2"
						/>

						<NavigationLink
							:link="{ name: 'invitations' }"
							:title="$t('invitations').toString()"
							fa-icon-type="fas"
							fa-icon-name="user-plus"
							v-if="isUserAllowedInLevel3"
						/>
					</NavigationGroup>

					<NavigationGroup :title="$t('damage_assessor').toString()" v-show="isLevel2Admin">
						<NavigationLink
							:link="{ name: 'damageassessor.editpdfpricing' }"
							:title="$t('fee_agreement').toString()"
							fa-icon-type="fas"
							fa-icon-name="money-bill"
							v-if="isLevel2Admin"
							:active="checkActiveStatus('damageassessor/editpdfpricing')"
						/>
					</NavigationGroup>

					<NavigationGroup :title="$store.getters.repairShopLabel" v-show="isUserAllowedInLevel5or6 || isUserAllowedInLevel1">
						<NavigationLink
							:link="{ name: 'repair_shop.service_provider' }"
							:title="$t('service_provider').toString()"
							fa-icon-type="fas"
							fa-icon-name="tools"
							:disabled="checkPaymentStatus"
							:active="checkActiveStatus('service_provider')"
							v-if="isUserAllowedInLevel5or6 && isAuthenticatedUserInGroupAdmin"
						/>
						<NavigationLink
							:link="{ name: 'repair_shop.company_ads' }"
							:title="$t('company_ads').toString()"
							fa-icon-type="fas"
							fa-icon-name="bullhorn"
							:disabled="checkPaymentStatus"
							:active="checkActiveStatus('company_ads')"
							v-if="isUserAllowedInLevel5or6"
						/>
						<NavigationLink
							:link="{ name: 'repair_shop.ad_templates' }"
							:title="$t('marketing_templates').toString()"
							fa-icon-type="fas"
							fa-icon-name="bullhorn"
							:active="checkActiveStatus('ad_templates')"
							v-if="isUserAllowedInLevel1"
						/>
						<NavigationLink
							:link="{ name: 'rentalcars' }"
							:title="$t('rental_car_administration').toString()"
							fa-icon-type="fas"
							fa-icon-name="car"
							:disabled="checkPaymentStatus"
							:active="checkActiveStatus('rentalcars')"
							v-if="isUserAllowedInLevel5or6"
						/>
						<NavigationLink
							:link="{ name: 'rentalcar.pricing' }"
							:title="$t('rental_car_pricing').toString()"
							fa-icon-type="fas"
							fa-icon-name="euro-sign"
							:disabled="checkPaymentStatus"
							v-if="isUserAllowedInLevel5or6"
						/>
						<NavigationLink
							:link="{ name: 'rentalcarcontract.return' }"
							:title="$t('rental_car_return').toString()"
							fa-icon-type="fas"
							fa-icon-name="undo"
							:disabled="checkPaymentStatus"
							v-if="isUserAllowedInLevel5or6 && isAppContainer"
							:active="checkActiveStatus('rentalcarcontractreturn')"
						/>
						<NavigationLink
							:link="{ name: 'repairplantasks' }"
							:title="$t('repair_plan_short').toString()"
							fa-icon-type="fas"
							fa-icon-name="toolbox"
							:disabled="checkPaymentStatus"
							v-if="(isUserAllowedInLevel5or6 && isAuthenticatedUserInGroupAdmin) || isUserAllowedInLevel1"
						/>
						<NavigationLink
							:link="{ name: 'orderdocumentationtypes' }"
							:title="$t('order_types').toString()"
							fa-icon-type="fas"
							fa-icon-name="clipboard-list"
							:disabled="checkPaymentStatus"
							v-if="(isUserAllowedInLevel5or6 && isAuthenticatedUserInGroupAdmin) || isUserAllowedInLevel1"
						/>
						<NavigationLink
							:link="{ name: 'employee_app' }"
							:title="$t('employee_app').toString()"
							fa-icon-type="fas"
							fa-icon-name="mobile-alt"
							:disabled="checkPaymentStatus"
							:active="isRouteActive('employee_app')"
							v-if="isUserAllowedInLevel1 || isUserAllowedInLevel5or6"
						/>
						<NavigationLink
							:link="{ name: 'connect_app' }"
							:title="$t('connect_pro_app').toString()"
							fa-icon-type="fas"
							fa-icon-name="tablet-alt"
							:disabled="checkPaymentStatus"
							:active="isRouteActive('connect_app')"
							v-if="isUserAllowedInLevel1 || isUserAllowedInLevel5or6"
						/>
					</NavigationGroup>

					<NavigationGroup :title="$t('system_administration').toString()" v-show="isUserAllowedInLevel1">
						<NavigationLink
							:link="{ name: 'rentalcars' }"
							:title="$t('rental_car_administration').toString()"
							fa-icon-type="fas"
							fa-icon-name="taxi"
							:active="checkActiveStatus('rentalcars')"
							v-if="isUserAllowedInLevel1"
						/>

						<NavigationLink
							:link="{ name: 'vehicles.overview' }"
							:title="$t('manufacturer_and_models').toString()"
							fa-icon-type="fas"
							fa-icon-name="car"
							:active="checkActiveStatus('vehicles')"
							v-if="isUserAllowedInLevel1"
						/>

						<NavigationLink
							:link="{ name: 'administrate_companies', params: { type: 'insurance' } }"
							:title="$t('insurances').toString()"
							fa-icon-type="fas"
							fa-icon-name="shield-alt"
							:active="checkActiveStatus('insurance', true) || checkActiveStatus('companyprofile/insurance/')"
							v-if="isUserAllowedInLevel1"
						/>

						<NavigationLink
							:link="{ name: 'text_templates' }"
							:title="$t('templates').toString()"
							fa-icon-type="fas"
							fa-icon-name="mail-bulk"
							:active="checkActiveStatus('text_templates')"
							v-if="isUserAllowedInLevel1"
						/>

						<NavigationLink
							:link="{ name: 'adminSystemSettings' }"
							:title="$t('admin_settings').toString()"
							fa-icon-type="fas"
							fa-icon-name="wrench"
							:active="isRouteActive('adminSystemSettings')"
							v-if="isUserAllowedInLevel1"
						/>
					</NavigationGroup>
				</div>
			</NavigationList>
			<div class="self-center">
				<PremiumBadge class="self-center" style="color: #cdd2dd" v-if="isPremiumLawyer" />
				<!--
				<PremiumBadge class="self-center" style="color: #b8860b" v-if="isPremiumLawyer" />
				-->
				<!--
				<p class="pt-2 " style="color: #cdd2dd">Version 2.0.0</p>
				-->
			</div>
		</aside>
	</div>
</template>

<script>
import NavigationList from '@/components/navigation/NavigationList';
import NavigationGroup from '@/components/navigation/NavigationGroup';
import NavigationLink from '@/components/navigation/NavigationLink';
import Authentication from '@/mixins/Authentication';
import AppContainerMixin from '@/mixins/AppContainerMixin';
import { getL2AdminID } from '@/helpers/Utils';
import PremiumBadge from '@/components/misc/premium-lawyer-badge.vue';

export default {
	components: {
		PremiumBadge,
		NavigationList,
		NavigationGroup,
		NavigationLink,
	},
	mixins: [Authentication, AppContainerMixin],
	props: {
		menuOpened: {},
	},
	data() {
		return {
			isOpen: true,
			notificationCount: 0,
		};
	},
	mounted() {
		if (this.$store.getters.getUnreadChatsCount) {
			this.notificationCount = this.$store.getters.getUnreadChatsCount.total;
		}
	},
	methods: {
		getL2AdminID,
		toggleIsOpen() {
			if (window.innerWidth <= 1023) {
				// tailwind md
				this.isOpen = !this.isOpen;
			}
		},
		checkActiveStatus(navPoint, endsWith = false) {
			if (endsWith) {
				return this.$route.path.endsWith(navPoint);
			}
			return this.$route.path.includes(navPoint);
		},
		isRouteActive(name) {
			return this.$route.name === name;
		},
	},
	computed: {
		getNotificationCount() {
			return this.notificationCount;
		},
		isMobileView() {
			return this.$store.getters.getIsMobileView;
		},
		icon() {
			if (!this.isOpen) {
				return ['fas', 'arrow-right'];
			} else {
				return ['fas', 'arrow-left'];
			}
		},
		checkPaymentStatus() {
			return this.isUserAllowedInLevel5or6 ? !this.$store.getters.getUser.stripePaymentStored : false;
		},
		isPremiumLawyer() {
			if (this.$store.getters.getAuthenticatedUserGroupLevel === '3') {
				return (
					!!this.$store.getters.getUser.person.company.companyable.is_premium_partner &&
					!!this.$store.getters.getUser.person.company.companyable.premium_partner_contract_accept
				);
			} else {
				return false;
			}
		},
	},
	destroyed() {
		window.document.documentElement.classList.remove('disableScroll');
	},
	watch: {
		'$store.getters.getUnreadChatsCount': function() {
			this.notificationCount = this.$store.getters.getUnreadChatsCount.total;
		},
	},
};
</script>

<style lang="sass" scoped>
aside
  background-color: $sp_secondary
  box-shadow: 0 14px 4px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22)
</style>
